import React  from 'react';
import { OneSectionPage } from './home_page_sections/OneSection';
import { TwoSections } from './home_page_sections/TwoSection';
import { ThreeSections } from './home_page_sections/ThreeSection';

export const HomePage = (props) => {
    return(
        <div className="homePage">
            <OneSectionPage />
            <TwoSections />
            <ThreeSections />
        </div>
    )
}
